(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["s-associated-products"] && !Shopify.designMode) return;
  try {
    
  // Écouteur délégué des événements de clic
  document.querySelector('.s-associated-products').addEventListener('click', (event) => {
    let clickEventPath = event.composedPath().slice(0, -2);

    for (element of clickEventPath) {
      if ('previous' in element.dataset) {
        previousSlideClickHandler(element, document.querySelector('.s-associated-products'));
        break;
      } else if ('next' in element.dataset) {
        nextSlideClickHandler(element, document.querySelector('.s-associated-products'));
        break;
      }
    }
  });

  // Gestionnaire du bouton précédent
  function previousSlideClickHandler(element, section) {
    scrollToSlide('previous');
  }

  // Gestionnaire du bouton suivant
  function nextSlideClickHandler(element, section) {
    scrollToSlide('next');
  }

  // Gestionnaire du scroll
  function scrollToSlide(command) {
    let numberOfItems = document.querySelectorAll('.s-associated-products li').length;
    let itemWidth = document.querySelector('.s-associated-products li').offsetWidth;
    let sliderGap = parseInt(window.getComputedStyle(document.querySelector('.s-associated-products ul')).gap);
    let numberOfItemsOnScreen = parseFloat(
      (document.querySelector('.s-associated-products ul').offsetWidth / (itemWidth + sliderGap)).toFixed(2)
    );
    let sliderScrollOffset = document.querySelector('.s-associated-products ul').scrollLeft;
    let activeItemIndex = Math.ceil(sliderScrollOffset / (itemWidth + sliderGap));
    let nextItemIndex;

    switch (command) {
      case 'previous':
        nextItemIndex = activeItemIndex - 1;
        if (nextItemIndex < 0) {
          nextItemIndex = numberOfItems - Math.floor(numberOfItemsOnScreen);
        }
        break;
      case 'next':
        nextItemIndex = activeItemIndex + 1;
        if (nextItemIndex > numberOfItems - Math.floor(numberOfItemsOnScreen)) {
          nextItemIndex = 0;
        }
        break;
      default:
        nextItemIndex = Math.floor(sliderScrollOffset / (itemWidth + sliderGap));
    }

    let nextSliderOffset = nextItemIndex * (itemWidth + sliderGap);

    document.querySelector('.s-associated-products ul').scroll({ left: nextSliderOffset, behavior: 'smooth' });
  }

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  if (productRecommendationsSection !== null) {
    observer.observe(productRecommendationsSection)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-mobile-cart"] && !Shopify.designMode) return;
  try {
    
  const shopUrl = 'https://naturaloe.org';

  // Gestion de l'ouverture du panier
  document.querySelectorAll('.icon_cart > a').forEach((element) => {
    element.addEventListener('click', (event) => {
      event.preventDefault();

      updateMobileCartVisibility('show');
    });
  });

  // Afficher le panier (si paramètre d'URL adéquat)
  window.addEventListener('load', (event) => {
    let showCart = window.location.search
      .split('?')
      .pop()
      .split('&')
      .find((element) => {
        return element === 'show-cart';
      });

    if (typeof showCart !== 'undefined') {
      updateMobileCartVisibility('show');
    }
  });

  // Fonction gérant l'ouverture et la fermeture du panier mobile
  function updateMobileCartVisibility(command) {
    let body = document.querySelector('body');
    let header = document.querySelector('header > div');
    let mobileCartSection = document.querySelector('#shopify-section-s-mobile-cart');
    let mobileCart = mobileCartSection.querySelector('.s-mobile-cart');
    let screenWidth = window.screen.width;

    switch (command) {
      case 'show':
        mobileCartSection.style.display = 'block';
        body.style.overflow = 'hidden';

        if (screenWidth > 600) {
          body.style.paddingRight = 17 + 'px';
          if (window.scrollY > 240) {
            header.style.paddingRight = 17 + 'px';
          }
        }

        // QB 17/09/2026 : le tiroir est recherché au moment d'ouvrir, pas avant. Un
        // rafraîchissement arrivé dans ces 100 ms a remplacé `mobileCart` : l'ouvrir
        // laisserait le nouveau tiroir invisible et la page bloquée.
        setTimeout(() => {
          mobileCartSection.querySelector('.s-mobile-cart')?.setAttribute('data-active', '');
        }, 100);

        break;
      case 'hide':
      default:
        mobileCart.removeAttribute('data-note-edition');
        mobileCart.removeAttribute('data-active');

        setTimeout(() => {
          mobileCartSection.style.display = null;
          body.style.overflow = null;

          if (screenWidth > 600) {
            body.style.paddingRight = null;
            header.style.paddingRight = null;
          }
        }, 300);
    }
  }
  window.updateMobileCartVisibility = updateMobileCartVisibility;

  // Écouteur délégué d'ajout au panier (clic)
  window.addEventListener('click', (event) => {
    let addToCartEventPath = event.composedPath().slice(0, -2);

    let addToCartEventElement = addToCartEventPath.find((element) => {
      let addToCartButton = element?.getAttribute('data-add-to-cart');

      return addToCartButton !== null;
    });

    let sellingPlanInput = document.querySelector('form[action*="/cart/add"] input[name="selling_plan"]')

    if (typeof addToCartEventElement === 'undefined') return false;

    event.preventDefault();

    let variantId = addToCartEventElement.getAttribute('data-id');
    let quantity = addToCartEventElement.getAttribute('data-quantity');
    let sellingPlanId = sellingPlanInput?.value;

    addCartItemHandler(variantId, quantity, sellingPlanId);
  });

  // Écouteur délégué de changement de quantité produit (clic)
  window.addEventListener('click', (event) => {
    let changeQuantityEventPath = event.composedPath().slice(0, -2);

    let changeQuantityEventElement = changeQuantityEventPath.find((element) => {
      let plusButton = element?.classList.contains('plus');
      let minusButton = element?.classList.contains('minus');

      return plusButton || minusButton;
    });

    if (typeof changeQuantityEventElement === 'undefined') return false;

    let newQuantity = changeQuantityEventElement.parentElement.parentElement.querySelector('input').value;

    let addToCartButton =
      changeQuantityEventElement.parentElement.parentElement.parentElement.querySelector('[data-add-to-cart]');

    addToCartButton.setAttribute('data-quantity', newQuantity);
  });

  // Écouteur délégué de changement de variante produit (clic)
  window.addEventListener('click', (event) => {
    let changeQuantityEventPath = event.composedPath().slice(0, -2);

    let changeQuantityEventElement = changeQuantityEventPath.find((element) => {
      let variantButton = element?.hasAttribute('data-swatch-itemt4');

      return variantButton !== false;
    });

    if (typeof changeQuantityEventElement === 'undefined') return false;

    // Si variante indisponible, stop

    // Élément parent
    let optionsParentElement = changeQuantityEventElement.parentElement.parentElement.parentElement;

    // Bouton d'ajout au panier
    let addToCartButton =
      changeQuantityEventElement.parentElement.parentElement.parentElement.parentElement.querySelector(
        '[data-add-to-cart]'
      );

    let newVariantId;

    // Vérification s'il y a des options
    let numberOfOptions = optionsParentElement.querySelectorAll('[data-opname]').length;

    if (numberOfOptions === 1) {
      let firstOptionValue = optionsParentElement.querySelector('.nt-swatch.is-selected')?.getAttribute('data-value');

      newVariantId = addToCartButton.nextElementSibling.querySelector(
        `option[data-variant-title='${firstOptionValue}']`
      ).value;
    } else if (numberOfOptions === 2) {
      // Cas 2
    } else if (numberOfOptions === 3) {
      // Cas 3
    } else {
      return false;
    }

    addToCartButton.setAttribute('data-id', newVariantId);
  });

  // Écouteur délégué d'événements du panier (clic)
  document.querySelector('#shopify-section-s-mobile-cart').addEventListener('click', (event) => {
    let cartClickEventPath = event.composedPath().slice(0, -2);

    let cartClickEventElement = cartClickEventPath.find((element) => {
      let minusQuantity = element.classList.contains('item-quantity-minus');
      let plusQuantity = element.classList.contains('item-quantity-plus');
      let removeItem = element.classList.contains('item-remove');
      let editNote = element.classList.contains('cart-note-edit');
      let saveNote = element.classList.contains('cart-note-save');
      let closeNote = element.classList.contains('cart-note-overlay');
      let upsellArrow = element.classList.contains('cart-upsells-arrow');
      let upsellToCart = element.classList.contains('cart-upsell-button');
      let removeUpsell = element.classList.contains('discounted-item-remove');
      let updateUpsellVisibility = element.classList.contains('upsell-close');
      let closeCart = element.classList.contains('cart-close') || element.classList.contains('cart-overlay');

      return (
        minusQuantity ||
        plusQuantity ||
        removeItem ||
        editNote ||
        saveNote ||
        closeNote ||
        upsellArrow ||
        upsellToCart ||
        removeUpsell ||
        updateUpsellVisibility ||
        closeCart
      );
    });

    if (typeof cartClickEventElement === 'undefined') return false;

    let cartElement = document.querySelector('.s-mobile-cart');

    if (cartClickEventElement.classList.contains('item-quantity-minus')) {
      minusCartItemQuantityHandler(cartClickEventElement.parentElement.parentElement.parentElement.parentElement);
    } else if (cartClickEventElement.classList.contains('item-quantity-plus')) {
      plusCartItemQuantityHandler(cartClickEventElement.parentElement.parentElement.parentElement.parentElement);
    } else if (cartClickEventElement.classList.contains('item-remove')) {
      removeCartItemHandler(cartClickEventElement.parentElement.parentElement.parentElement);
    } else if (cartClickEventElement.classList.contains('cart-note-edit')) {
      editCheckoutNoteHandler(cartElement);
    } else if (cartClickEventElement.classList.contains('cart-note-save')) {
      saveCheckoutNoteHandler(cartElement);
    } else if (cartClickEventElement.classList.contains('cart-note-overlay')) {
      closeCheckoutNoteHandler(cartElement);
    } else if (cartClickEventElement.classList.contains('cart-upsells-arrow')) {
      if (cartClickEventElement.hasAttribute('data-previous')) {
        updateUpsellsSliderPosition('previous');
      } else {
        updateUpsellsSliderPosition('next');
      }
    } else if (cartClickEventElement.classList.contains('cart-upsell-button')) {
      addUpsellToCart(cartClickEventElement.parentElement);
    } else if (cartClickEventElement.classList.contains('discounted-item-remove')) {
      removeCartItemHandler(cartClickEventElement);
    } else if (cartClickEventElement.classList.contains('upsell-close')) {
      updateUpsellVisibility(cartClickEventElement.parentElement.parentElement);
    } else if (
      cartClickEventElement.classList.contains('cart-close') ||
      cartClickEventElement.classList.contains('cart-overlay')
    ) {
      updateMobileCartVisibility('hide');
    }
  });

  // Écouteur délégué d'événements du panier (change)
  document.querySelector('#shopify-section-s-mobile-cart').addEventListener('change', (event) => {
    let cartChangeEventPath = event.composedPath().slice(0, -2);

    let cartChangeEventElement = cartChangeEventPath.find((element) => {
      return element.classList.contains('item-quantity-value');
    });

    if (typeof cartChangeEventElement === 'undefined') return false;

    if (cartChangeEventElement.classList.contains('item-quantity-value')) {
      changeCartItemQuantityHandler(cartChangeEventElement.parentElement.parentElement.parentElement.parentElement);
    }
  });

  // Fonction gestionnaire de l'événement d'ajout d'un produit dans le panier
  async function addCartItemHandler(variantId, quantity, sellingPlanId) {
    const result = await fetch(`${shopUrl}/cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: variantId, quantity: quantity, selling_plan: sellingPlanId}),
    });

    if (!result.ok) {
      console.error(result);
      return false;
    }

    // On cache la vue express
    document?.querySelectorAll('.mfp-bg, .mfp-wrap').forEach((element) => element?.classList.add('mfp-removing'));

    setTimeout(() => {
      document?.querySelectorAll('.mfp-bg, .mfp-wrap').forEach((element) => element?.remove());
    }, 800);

    // Mise à jour de l'UI
    await updateMobileCartContents('keep-hidden');

    // Affichage du panier
    updateMobileCartVisibility('show');
  }

  // Fonction gestionnaire de l'événément de mise à jour de la note de commande
  async function editCheckoutNoteHandler(cart) {
    // On récupère la note
    const result = await fetch(`/cart.js`, {
      method: 'GET',
    });

    if (!result.ok) {
      console.error(result);
      return false;
    }

    let cartJson = await result.json();

    let cartNoteContent = '';

    if (cartJson.note !== null) {
      cartNoteContent = cartJson.note;
    }

    // On remplace le contenu du textarea
    cart.querySelector('.cart-note-input').value = cartNoteContent;

    // On affiche la section édition de note
    cart.setAttribute('data-note-edition', '');
  }

  // Fonction gestionnaire de l'événements de sauvegarde de la note de commande
  async function saveCheckoutNoteHandler(cart) {
    // On récupère le contenu du textarea
    let noteContents = cart.querySelector('.cart-note-input').value;

    // On sauvegarde le contenu de la note
    const result = await fetch(`${shopUrl}/cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ note: noteContents }),
    });

    if (!result.ok) {
      console.error(result);
      return false;
    }

    // On cache la section édition de note
    cart.removeAttribute('data-note-edition');
  }

  // Fonction gestionnaire de l'événement de fermeture de la note de commande
  async function closeCheckoutNoteHandler(cart) {
    cart.removeAttribute('data-note-edition');
  }

  // Fonction gestionnaire de l'événement de diminution de la quantité d'un produit dans le panier
  async function minusCartItemQuantityHandler(cartItem) {
    // Récupération de l'identifiant de la variante
    let variantId = cartItem.dataset.variantId;
    let lineKey = cartItem.dataset.lineKey;

    // Récupération de la quantité actuelle
    let currentQuantity = parseInt(cartItem.dataset.quantity);

    // Calcul de la prochaine quantité
    let quantityStep = parseInt(cartItem.dataset.step);
    let newQuantity = currentQuantity - quantityStep;

    // Mise à jour du panier
    if (newQuantity <= 0) {
      await updateMobileCartData(lineKey, 0);
    } else {
      await updateMobileCartData(lineKey, newQuantity);
    }

    // Vérification de la validité des upsells
    await checkCartUpsellValidity();

    // Mise à jour de l'UI
    updateMobileCartContents();
  }

  // Fonction gestionnaire de l'événement de l'augmentation de la quantité d'un produit dans le panier
  async function plusCartItemQuantityHandler(cartItem) {
    // Récupération de l'identifiant de la variante
    let variantId = cartItem.dataset.variantId;
    let lineKey = cartItem.dataset.lineKey;

    // Récupération de la quantité actuelle
    let currentQuantity = parseInt(cartItem.dataset.quantity);

    // Calcul de la prochaine quantité
    let quantityStep = parseInt(cartItem.dataset.step);
    let newQuantity = currentQuantity + quantityStep;

    // Mise à jour du panier
    await updateMobileCartData(lineKey, newQuantity);

    // Mise à jour de l'UI
    updateMobileCartContents();
  }

  // Fonction gestionnaire de l'événement du changement de quantité d'un produit dans le panier
  async function changeCartItemQuantityHandler(cartItem) {
    // Récupération de l'identifiant de la variante
    let variantId = cartItem.dataset.variantId;
    let lineKey = cartItem.dataset.lineKey;

    // Récupération de la nouvelle quantité
    let newQuantity = parseInt(cartItem.querySelector('.item-quantity-value').value);
    let additionalQuantity = parseInt(cartItem.dataset.additionalQuantity);

    // Mise à jour du panier
    if (newQuantity <= 0) {
      await updateMobileCartData(lineKey, 0);
    } else {
      await updateMobileCartData(lineKey, newQuantity - additionalQuantity);
    }

    // Vérification de la validité des upsells
    await checkCartUpsellValidity();

    // Mise à jour de l'UI
    updateMobileCartContents();
  }

  // Fonction gestionnaire de l'événement de suppression d'un produit dans le panier
  async function removeCartItemHandler(cartItem) {
    // Récupération de l'identifiant de la variante
    let variantId = cartItem.dataset.variantId;
    let lineKey = cartItem.dataset.lineKey;

    // Mise à jour du panier
    if (cartItem.classList.contains('discounted-item-remove')) {
      await updateMobileCartData(lineKey, 0);
    } else {
      await updateMobileCartData(variantId, 0);
    }

    // Vérification de la validité des upsells
    await checkCartUpsellValidity();

    // Mise à jour de l'UI
    updateMobileCartContents();
  }

  // Fonction gestionnaire de l'événement de mise à jour de la position du slider des upsells
  async function updateUpsellsSliderPosition(command) {
    let upsellSlider = document.querySelector('.cart-upsells-slider');
    let upsellCard = upsellSlider.querySelector('.b-cart-upsell');

    let cardWidth = upsellCard.offsetWidth;
    let sliderGap = 24;
    let numberOfCards = upsellSlider.childElementCount;
    let numberOfCardsOnScreen = 2;

    let sliderOffset = upsellSlider.scrollLeft;

    let currentCardIndex = Math.trunc(sliderOffset / (cardWidth + sliderGap));

    let nextCardIndex, nextSliderOffset;

    switch (command) {
      case 'previous':
        if (currentCardIndex === 0) {
          nextCardIndex = numberOfCards - (numberOfCardsOnScreen - 1);
        } else {
          nextCardIndex = currentCardIndex - 1;
        }

        break;
      case 'next':
      default:
        if (currentCardIndex === numberOfCards - numberOfCardsOnScreen) {
          nextCardIndex = 0;
        } else {
          nextCardIndex = currentCardIndex + 1;
        }
    }

    nextSliderOffset = nextCardIndex * (cardWidth + sliderGap);

    upsellSlider.scroll({ left: nextSliderOffset, behavior: 'smooth' });
  }

  // Fonction mettant à jour les données du panier
  async function updateMobileCartData(id, quantity) {
    const result = await fetch(`${shopUrl}/cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: id, quantity: quantity }),
    });

    if (!result.ok) {
      console.error(result);
      return false;
    }
  }

  // QB 17/09/2026 : plusieurs sources rafraîchissent le tiroir (le thème, nos ménages,
  // les apps via Shopify.actions). Seul le DERNIER rafraîchissement lancé écrit dans le
  // DOM : une réponse plus ancienne, arrivée après, n'écrase pas un panier plus récent.
  let qbDernierRafraichissement = 0;

  // Fonction mettant à jour l'aspect visuel du panier
  async function updateMobileCartContents(command) {
    const qbTour = ++qbDernierRafraichissement;
    const result = await fetch(`/?view=cart`, {
      method: 'GET',
    });

    if (!result.ok) {
      console.error(result);
      return false;
    }

    let resultString = await result.text();

    if (qbTour !== qbDernierRafraichissement) return false;

    let parser = new DOMParser();
    let resultHtml = parser.parseFromString(resultString, 'text/html');

    let cartContents = resultHtml.querySelector('.s-mobile-cart');

    // 'keep-hidden' = ne pas ouvrir le tiroir ; déjà ouvert, il le reste (QB 14/09/2026).
    let cartAlreadyOpen = document.querySelector('.s-mobile-cart')?.hasAttribute('data-active');

    if (command !== 'keep-hidden' || cartAlreadyOpen) {
      cartContents.setAttribute('data-active', '');
    }

    // Mise à jour du nombre de produits dans l'icone panier
    let numberOfProducts = parseInt(cartContents.getAttribute('data-cart-size'));

    let numberOfProductsElement = document.querySelector('.icon_cart span');

    numberOfProductsElement.textContent = numberOfProducts;

    if (numberOfProducts === 0) {
      numberOfProductsElement.style.display = 'none';
    } else {
      numberOfProductsElement.style.display = 'block';
    }

    // Mise à jour de l'ouverture de la fenêtre des upsells
    let keepUpsellContainerClosed =
      document.querySelector('.s-mobile-cart .cart-upsells-container[data-keep-closed]') !== null;

    let openedUpsellContainer = document
      .querySelector('.s-mobile-cart .cart-upsells-container')
      .hasAttribute('data-active');

    if (keepUpsellContainerClosed) {
      cartContents.querySelector('.cart-upsells-container').removeAttribute('data-active');
      cartContents.querySelector('.cart-upsells-container').setAttribute('data-keep-closed', '');
    }

    document.querySelector('.s-mobile-cart').remove();
    document.querySelector('#shopify-section-s-mobile-cart').prepend(cartContents);
  }
  window.updateMobileCartContents = updateMobileCartContents;

  // QB 17/09/2026 : le rafraîchissement déclaré à Shopify.actions.updateCart est posé
  // par le module en fin de balisage de cette section (voir son commentaire).

  // Fonction gestionnaire de l'ouverture / fermeture de la partie upsell
  function updateUpsellVisibility(upsellContainer) {
    if (upsellContainer?.hasAttribute('data-active')) {
      upsellContainer.removeAttribute('data-active');
      upsellContainer.setAttribute('data-keep-closed', '');
    } else {
      upsellContainer.setAttribute('data-active', '');
      upsellContainer.removeAttribute('data-keep-closed');
    }
  }

  // Fonction gestionnaire de l'ajout au panier des upsells
  async function addUpsellToCart(upsell) {
    // Récupération de la règle
    let upsellAttributeValue = '';

    if (upsell?.hasAttribute('data-first-quantity')) {
      upsellAttributeValue = 'firstQuantity';
    } else if (upsell?.hasAttribute('data-second-quantity')) {
      upsellAttributeValue = 'secondQuantity';
    } else if (upsell?.hasAttribute('data-third-quantity')) {
      upsellAttributeValue = 'thirdQuantity';
    } else if (upsell?.hasAttribute('data-first-price')) {
      upsellAttributeValue = 'firstPrice';
    } else if (upsell?.hasAttribute('data-second-price')) {
      upsellAttributeValue = 'secondPrice';
    } else if (upsell?.hasAttribute('data-third-price')) {
      upsellAttributeValue = 'thirdPrice';
    } else if (upsell?.hasAttribute('data-fourth-price')) {
      upsellAttributeValue = 'fourthPrice';
    } else if (upsell?.hasAttribute('data-fifth-price')) {
      upsellAttributeValue = 'fifthPrice';
    } else if (upsell?.hasAttribute('data-first-sample')) {
      upsellAttributeValue = 'firstSample';
    } else if (upsell?.hasAttribute('data-second-sample')) {
      upsellAttributeValue = 'secondSample';
    } else if (upsell?.hasAttribute('data-third-sample')) {
      upsellAttributeValue = 'thirdSample';
    } else if (upsell?.hasAttribute('data-fourth-sample')) {
      upsellAttributeValue = 'fourthSample';
    } else if (upsell?.hasAttribute('data-fifth-sample')) {
      upsellAttributeValue = 'fifthSample';
    } else if (upsell?.hasAttribute('data-sixth-sample')) {
      upsellAttributeValue = 'sixthSample';
    } else if (upsell?.hasAttribute('data-seventh-sample')) {
      upsellAttributeValue = 'seventhSample';
    } else if (upsell?.hasAttribute('data-eighth-sample')) {
      upsellAttributeValue = 'eighthSample';
    } else if (upsell?.hasAttribute('data-ninth-sample')) {
      upsellAttributeValue = 'ninthSample';
    } else if (upsell?.hasAttribute('data-tenth-sample')) {
      upsellAttributeValue = 'tenthSample';
    }

    if (upsellAttributeValue === '') return false;

    let upsellAttribute = { _upsell: upsellAttributeValue };

    // Récupération de l'identifiant et de la quantité
    let variantId = upsell.querySelector('.cart-upsell-button').getAttribute('data-id');
    let quantity = upsell.querySelector('.cart-upsell-button').getAttribute('data-quantity');

    // On ajoute l'upsell au panier
    const result = await fetch(`${shopUrl}/cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        properties: upsellAttribute,
      }),
    });

    if (!result.ok) {
      console.error(result);
      return false;
    }

    // Mise à jour de l'UI
    updateMobileCartContents();
  }

  // Fonction gestionnaire de la vérification des upsells dans le panier
  async function checkCartUpsellValidity() {
    // On récupère les données d'upsells
    let upsellRules = JSON.parse(document.querySelector('.cart-upsells-container script').textContent);

    // On récupère les données du panier
    const result = await fetch(`/cart.js`, {
      method: 'GET',
    });

    if (!result.ok) {
      console.error(result);
      return false;
    }

    let cartData = await result.json();

    let cartItems = cartData.items;

    // On vérifie s'il y a des upsells dans le panier
    let firstQuantityUpsellInCart = false;
    let secondQuantityUpsellInCart = false;
    let thirdQuantityUpsellInCart = false;
    let firstPriceUpsellInCart = false;
    let secondPriceUpsellInCart = false;
    let thirdPriceUpsellInCart = false;
    let fourthPriceUpsellInCart = false;
    let fifthPriceUpsellInCart = false;
    let firstSampleUpsellInCart = false;
    let secondSampleUpsellInCart = false;
    let thirdSampleUpsellInCart = false;
    let fourthSampleUpsellInCart = false;
    let fifthSampleUpsellInCart = false;
    let sixthSampleUpsellInCart = false;
    let seventhSampleUpsellInCart = false;
    let eighthSampleUpsellInCart = false;
    let ninthSampleUpsellInCart = false;
    let tenthSampleUpsellInCart = false;

    for (let i = 0; i < cartItems.length; i++) {
      let currentItem = cartItems[i];

      switch (currentItem.properties['_upsell']) {
        case 'firstQuantity':
          firstQuantityUpsellInCart = true;
          break;
        case 'secondQuantity':
          secondQuantityUpsellInCart = true;
          break;
        case 'thirdQuantity':
          thirdQuantityUpsellInCart = true;
          break;
        case 'firstPrice':
          firstPriceUpsellInCart = true;
          break;
        case 'secondPrice':
          secondPriceUpsellInCart = true;
          break;
        case 'thirdPrice':
          thirdPriceUpsellInCart = true;
          break;
        case 'fourthPrice':
          fourthPriceUpsellInCart = true;
          break;
        case 'fifthPrice':
          fifthPriceUpsellInCart = true;
          break;
        case 'firstSample':
          firstSampleUpsellInCart = true;
          break;
        case 'secondSample':
          secondSampleUpsellInCart = true;
          break;
        case 'thirdSample':
          thirdSampleUpsellInCart = true;
          break;
        case 'fourthSample':
          fourthSampleUpsellInCart = true;
          break;
        case 'fifthSample':
          fifthSampleUpsellInCart = true;
          break;
        case 'sixthSample':
          sixthSampleUpsellInCart = true;
          break;
        case 'seventhSample':
          seventhSampleUpsellInCart = true;
          break;
        case 'eighthSample':
          eighthSampleUpsellInCart = true;
          break;
        case 'ninthSample':
          ninthSampleUpsellInCart = true;
          break;
        case 'tenthSample':
          tenthSampleUpsellInCart = true;
          break;
      }
    }

    // On vérifie les règles une-à-une
    // Règle quantité #1
    if (firstQuantityUpsellInCart) {
      let keepFirstQuantityUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.firstQuantity.present === 'no') {
        keepFirstQuantityUpsellInCart = false;
      }

      // On vérifie la condition
      let targetQuantity = upsellRules.firstQuantity.targetQuantity;
      let targetHandles = upsellRules.firstQuantity.targetProductList;

      let targetProductsInCart = 0;

      for (let i = 0; i < cartItems.length; i++) {
        for (let j = 0; j < targetHandles.length; j++) {
          if (cartItems[i].handle === targetHandles[j]) {
            targetProductsInCart = targetProductsInCart + cartItems[i].quantity;
          }
        }
      }

      if (targetProductsInCart < targetQuantity) {
        keepFirstQuantityUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepFirstQuantityUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'firstQuantity') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle quantité #2
    if (secondQuantityUpsellInCart) {
      let keepSecondQuantityUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.secondQuantity.present === 'no') {
        keepSecondQuantityUpsellInCart = false;
      }

      // On vérifie la condition
      let targetQuantity = upsellRules.secondQuantity.targetQuantity;
      let targetHandles = upsellRules.secondQuantity.targetProductList;

      let targetProductsInCart = 0;

      for (let i = 0; i < cartItems.length; i++) {
        for (let j = 0; j < targetHandles.length; j++) {
          if (cartItems[i].handle === targetHandles[j]) {
            targetProductsInCart = targetProductsInCart + cartItems[i].quantity;
          }
        }
      }

      if (targetProductsInCart < targetQuantity) {
        keepSecondQuantityUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepSecondQuantityUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'secondQuantity') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle quantité #3
    if (thirdQuantityUpsellInCart) {
      let keepThirdQuantityUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.thirdQuantity.present === 'no') {
        keepThirdQuantityUpsellInCart = false;
      }

      // On vérifie la condition
      let targetQuantity = upsellRules.thirdQuantity.targetQuantity;
      let targetHandles = upsellRules.thirdQuantity.targetProductList;

      let targetProductsInCart = 0;

      for (let i = 0; i < cartItems.length; i++) {
        for (let j = 0; j < targetHandles.length; j++) {
          if (cartItems[i].handle === targetHandles[j]) {
            targetProductsInCart = targetProductsInCart + cartItems[i].quantity;
          }
        }
      }

      if (targetProductsInCart < targetQuantity) {
        keepThirdQuantityUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepThirdQuantityUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'thirdQuantity') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle prix #1
    if (firstPriceUpsellInCart) {
      let keepFirstPriceUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.firstPrice.present === 'no') {
        keepFirstPriceUpsellInCart = false;
      }

      // On vérifie la condition
      let targetPrice = upsellRules.firstPrice.targetPrice;

      let cartPrice = cartData.total_price;

      if (cartPrice < targetPrice) {
        keepFirstPriceUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepFirstPriceUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'firstPrice') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle prix #2
    if (secondPriceUpsellInCart) {
      let keepSecondPriceUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.secondPrice.present === 'no') {
        keepSecondPriceUpsellInCart = false;
      }

      // On vérifie la condition
      let targetPrice = upsellRules.secondPrice.targetPrice;

      let cartPrice = cartData.total_price;

      if (cartPrice < targetPrice) {
        keepSecondPriceUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepSecondPriceUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'secondPrice') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle prix #3
    if (thirdPriceUpsellInCart) {
      let keepThirdPriceUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.thirdPrice.present === 'no') {
        keepThirdPriceUpsellInCart = false;
      }

      // On vérifie la condition
      let targetPrice = upsellRules.thirdPrice.targetPrice;

      let cartPrice = cartData.total_price;

      if (cartPrice < targetPrice) {
        keepThirdPriceUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepThirdPriceUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'thirdPrice') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle prix #4
    if (fourthPriceUpsellInCart) {
      let keepFourthPriceUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.fourthPrice.present === 'no') {
        keepFourthPriceUpsellInCart = false;
      }

      // On vérifie la condition
      let targetPrice = upsellRules.fourthPrice.targetPrice;

      let cartPrice = cartData.total_price;

      if (cartPrice < targetPrice) {
        keepFourthPriceUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepFourthPriceUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'fourthPrice') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle prix #5
    if (fifthPriceUpsellInCart) {
      let keepFifthPriceUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.fifthPrice.present === 'no') {
        keepFifthPriceUpsellInCart = false;
      }

      // On vérifie la condition
      let targetPrice = upsellRules.fifthPrice.targetPrice;

      let cartPrice = cartData.total_price;

      if (cartPrice < targetPrice) {
        keepFifthPriceUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepFifthPriceUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'fifthPrice') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle échantillon #1
    if (firstSampleUpsellInCart) {
      let keepFirstSampleUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.firstSample.present === 'no') {
        keepFirstSampleUpsellInCart = false;
      }

      // On vérifie la condition
      let targetPrice = upsellRules.firstSample.targetPrice;

      let cartPrice = cartData.total_price;

      if (cartPrice < targetPrice) {
        keepFirstSampleUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepFirstSampleUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'firstSample') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle échantillon #2
    if (secondSampleUpsellInCart) {
      let keepSecondSampleUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.secondSample.present === 'no') {
        keepSecondSampleUpsellInCart = false;
      }

      // On vérifie la condition
      let targetPrice = upsellRules.secondSample.targetPrice;

      let cartPrice = cartData.total_price;

      if (cartPrice < targetPrice) {
        keepSecondSampleUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepSecondSampleUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'secondSample') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle échantillon #3
    if (thirdSampleUpsellInCart) {
      let keepThirdSampleUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.thirdSample.present === 'no') {
        keepThirdSampleUpsellInCart = false;
      }

      // On vérifie la condition
      let targetPrice = upsellRules.thirdSample.targetPrice;

      let cartPrice = cartData.total_price;

      if (cartPrice < targetPrice) {
        keepThirdSampleUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepThirdSampleUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'thirdSample') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle échantillon #4
    if (fourthSampleUpsellInCart) {
      let keepFourthSampleUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.fourthSample.present === 'no') {
        keepFourthSampleUpsellInCart = false;
      }

      // On vérifie la condition
      let targetPrice = upsellRules.fourthSample.targetPrice;

      let cartPrice = cartData.total_price;

      if (cartPrice < targetPrice) {
        keepFourthSampleUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepFourthSampleUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'fourthSample') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle échantillon #5
    if (fifthSampleUpsellInCart) {
      let keepFifthSampleUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.fifthSample.present === 'no') {
        keepFifthSampleUpsellInCart = false;
      }

      // On vérifie la condition
      let targetPrice = upsellRules.fifthSample.targetPrice;

      let cartPrice = cartData.total_price;

      if (cartPrice < targetPrice) {
        keepFifthSampleUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepFifthSampleUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'fifthSample') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle échantillon #6
    if (sixthSampleUpsellInCart) {
      let keepSixthSampleUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.sixthSample.present === 'no') {
        keepSixthSampleUpsellInCart = false;
      }

      // On vérifie la condition
      let targetPrice = upsellRules.sixthSample.targetPrice;

      let cartPrice = cartData.total_price;

      if (cartPrice < targetPrice) {
        keepSixthSampleUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepSixthSampleUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'sixthSample') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle échantillon #7
    if (seventhSampleUpsellInCart) {
      let keepSeventhSampleUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.seventhSample.present === 'no') {
        keepSeventhSampleUpsellInCart = false;
      }

      // On vérifie la condition
      let targetPrice = upsellRules.seventhSample.targetPrice;

      let cartPrice = cartData.total_price;

      if (cartPrice < targetPrice) {
        keepSeventhSampleUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepSeventhSampleUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'seventhSample') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle échantillon #8
    if (eighthSampleUpsellInCart) {
      let keepEighthSampleUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.eighthSample.present === 'no') {
        keepEighthSampleUpsellInCart = false;
      }

      // On vérifie la condition
      let targetPrice = upsellRules.eighthSample.targetPrice;

      let cartPrice = cartData.total_price;

      if (cartPrice < targetPrice) {
        keepEighthSampleUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepEighthSampleUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'eighthSample') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle échantillon #9
    if (ninthSampleUpsellInCart) {
      let keepNinthSampleUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.ninthSample.present === 'no') {
        keepNinthSampleUpsellInCart = false;
      }

      // On vérifie la condition
      let targetPrice = upsellRules.ninthSample.targetPrice;

      let cartPrice = cartData.total_price;

      if (cartPrice < targetPrice) {
        keepNinthSampleUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepNinthSampleUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'ninthSample') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }

    // Règle échantillon #10
    if (tenthSampleUpsellInCart) {
      let keepTenthSampleUpsellInCart = true;

      // Si la règle n'est pas active, aucun produit ne doit être dans le panier
      if (upsellRules.tenthSample.present === 'no') {
        keepTenthSampleUpsellInCart = false;
      }

      // On vérifie la condition
      let targetPrice = upsellRules.tenthSample.targetPrice;

      let cartPrice = cartData.total_price;

      if (cartPrice < targetPrice) {
        keepTenthSampleUpsellInCart = false;
      }

      // Si la condition n'est pas respectée, on retire le produit du panier
      if (keepTenthSampleUpsellInCart === false) {
        let upsellId = '';

        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].properties['_upsell'] == 'tenthSample') {
            upsellId = cartItems[i].key;
            break;
          }
        }

        await updateMobileCartData(upsellId, 0);
      }
    }
  }

  window.addEventListener('load', (event) => {
    let urlParameters = window.location.search.slice(1).split('&');

    let formPosted = urlParameters.find((parameter) => {
      let formParameter = parameter.split('=')[0] === 'customer_posted';

      return formParameter;
    });

    if (typeof formPosted === 'undefined') return false;

    window.scroll(0, 0);
  });

  document.querySelector('.type_toolbar_cart.kalles_toolbar_item > a').addEventListener('click', (event) => {
    updateMobileCartVisibility('show');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-product-slider"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('.s-product-slider').forEach((element) => {
  element.addEventListener('click', (event) => {
    let sliderSection = element;
    let productSliderClickPath = event.composedPath().slice(0, -2);

    let productSliderClickElement = productSliderClickPath.find((element) => {
      return element.classList.contains('product-slider-arrow');
    });

    if (typeof productSliderClickElement === 'undefined') return false;

    if ('previous' in productSliderClickElement.dataset) {
      previousProductSliderHandler(sliderSection);
    }

    if ('next' in productSliderClickElement.dataset) {
      nextProductSliderHandler(sliderSection);
    }
  });
});

function previousProductSliderHandler(sliderSection) {
  if (window.innerWidth > 901) return false;

  let productSlider = sliderSection.querySelector('ul');
  let productCard = sliderSection.querySelector('li');

  let cardWidth = productCard.offsetWidth;
  let sliderGap = 32;
  let numberOfCardsOnScreen = 1;

  if (window.innerWidth > 361) numberOfCardsOnScreen = 2;

  if (window.innerWidth > 541) numberOfCardsOnScreen = 3;

  let productSliderOffset = productSlider.scrollLeft;

  let currentCardIndex = Math.trunc(productSliderOffset / cardWidth);

  let nextCardIndex = currentCardIndex - 1;

  if (currentCardIndex === 0) {
    nextCardIndex = 3;
  }

  let nextSliderOffset = nextCardIndex * (cardWidth + sliderGap);

  productSlider.scroll({ left: nextSliderOffset, behavior: 'smooth' });
}

function nextProductSliderHandler(sliderSection) {
  if (window.innerWidth > 901) return false;

  let productSlider = sliderSection.querySelector('ul');
  let productCard = sliderSection.querySelector('li');

  let cardWidth = productCard.offsetWidth;
  let sliderGap = 32;
  let numberOfCardsOnScreen = 1;

  if (window.innerWidth > 361) numberOfCardsOnScreen = 2;

  if (window.innerWidth > 541) numberOfCardsOnScreen = 3;

  let productSliderOffset = productSlider.scrollLeft;

  let currentCardIndex = Math.trunc(productSliderOffset / cardWidth);

  let nextCardIndex = currentCardIndex + 1;

  if (
    currentCardIndex > 2 ||
    (window.innerWidth > 361 && currentCardIndex > 1) ||
    (window.innerWidth > 541 && currentCardIndex > 0)
  ) {
    nextCardIndex = 0;
  }

  let nextSliderOffset = nextCardIndex * (cardWidth + sliderGap);

  productSlider.scroll({ left: nextSliderOffset, behavior: 'smooth' });
}


  } catch(e) { console.error(e); }
})();
})();
